import { Controller } from "@hotwired/stimulus"

// Shows a right-edge "more" affordance while a horizontal scroller has content
// off-screen; hides it once scrolled to the end or nothing overflows. Tapping
// it nudges the scroller further right.
export default class extends Controller {
  static targets = ["scroller", "hint", "leftHint"]

  connect() {
    // Restore scroll position across Turbo re-renders (e.g. search auto-submit)
    // so the row doesn't jump back to the start.
    const saved = sessionStorage.getItem(this.storageKey)
    if (saved) this.scrollerTarget.scrollLeft = Number(saved)
    this.update()
  }

  update() {
    const el = this.scrollerTarget
    sessionStorage.setItem(this.storageKey, el.scrollLeft)
    const more = el.scrollLeft + el.clientWidth < el.scrollWidth - 1
    this.hintTarget.classList.toggle("hidden", !more)
    this.leftHintTarget.classList.toggle("hidden", el.scrollLeft <= 1)
  }

  get storageKey() {
    return `scroll-hint:${this.element.id || location.pathname}`
  }

  scrollRight() {
    this.scrollerTarget.scrollBy({ left: this.scrollerTarget.clientWidth * 0.7, behavior: "smooth" })
  }

  scrollLeft() {
    this.scrollerTarget.scrollBy({ left: this.scrollerTarget.clientWidth * -0.7, behavior: "smooth" })
  }
}
